module.exports = __webpack_public_path__ + "static/media/Escuela2.654a8946.jpg";